export default "__VITE_ASSET__CRQLE9iW__"